<script lang="ts" setup>
import ConnxModal from './ConnxModal.vue';
import ConnxButton from '../Atoms/ConnxButton.vue';
import ConnxIcon from '../Atoms/ConnxIcon.vue';

interface Props {
  open: boolean;
  confirmationButtonText?: string;
  headingText?: string;
  size?: 'small' | 'medium' | 'large';
  closeButtonText?: string;
}

withDefaults(defineProps<Props>(), {
  confirmationButtonText: 'Yes, I\'m sure.',
  headingText: 'Are you sure?',
  closeButtonText: 'Cancel',
  size: 'small'
});

const emits = defineEmits(['close', 'confirmed']);

const onClose = () => {
  emits('close');
};
const onConfirmed = () => {
  emits('confirmed');
};
</script>

<template>
  <connx-modal
    :open="open"
    :size="size"
    @close="onClose()"
    z-index="tw-z-1200"
  >
    <div class="tw-text-center">
      <connx-icon
        name="fal fa-exclamation-circle"
        class="tw-w-20 tw-h-auto tw-mx-auto tw-text-connx-warning"
      />
      <h3 class="tw-text-xl tw-my-4">
        {{ headingText }}
      </h3>
      <slot></slot>
      <div class="
          tw-flex
          tw-flex-wrap
          tw-justify-center
          tw-items-center
          tw-space-x-2
          tw-mt-10
        ">
        <slot name="footer">
          <connx-button
            class="tw-min-w-32"
            button-style="success"
            @click="onConfirmed()"
          >
            {{ confirmationButtonText }}
          </connx-button>
          <connx-button
            class="tw-min-w-32"
            @click="onClose()"
          >
            {{ closeButtonText }}
          </connx-button>
        </slot>
      </div>
    </div>
  </connx-modal>
</template>
